module.exports = __webpack_public_path__ + "static/media/Intermediate.c47ffcff.svg";